import { render, staticRenderFns } from "./WhatsappBusinessChannels.vue?vue&type=template&id=5276f9c4&scoped=true"
import script from "./WhatsappBusinessChannels.vue?vue&type=script&lang=js"
export * from "./WhatsappBusinessChannels.vue?vue&type=script&lang=js"
import style0 from "./WhatsappBusinessChannels.vue?vue&type=style&index=0&id=5276f9c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5276f9c4",
  null
  
)

export default component.exports